import * as marietta from '../../..';

class OutColorMenu {
    viewObj: Element;

    tabWall1f: Element;

    tabKoshi1f: Element;

    tabWall2f: Element;

    tabKoshi2f: Element;

    tabWall3f: Element;

    tabKoshi3f: Element;

    /**
     * コンストラクタ
     */
    constructor() {
      this.viewObj = document.querySelector('#itemChangeMenu_gaiheki');
      this.tabWall1f = document.querySelector('#tabWall1f');
      this.tabKoshi1f = document.querySelector('#tabKoshi1f');
      this.tabWall2f = document.querySelector('#tabWall2f');
      this.tabKoshi2f = document.querySelector('#tabKoshi2f');
      this.tabWall3f = document.querySelector('#tabWall3f');
      this.tabKoshi3f = document.querySelector('#tabKoshi3f');
    }

    /**
     * 初期化
     */
    init() {
      this.viewObj.querySelectorAll('.tabContents').forEach((elem) => {
        const tabcontLen = elem.children.length;
        if (tabcontLen > 0) {
          for (let i = 0; i < tabcontLen; i += 1) {
            elem.children[0].remove();
          }
        }
      });
      this.createMaterialList();
      this.initFloors();

      this.viewObj.querySelectorAll('.tabMenu').forEach((elem) => {
        elem.querySelectorAll('label')[0].click();
      });
    }

    /**
     * カラー（テクスチャ）リストの生成
     */
    createMaterialList() {
      // 情報をGET
      const wallData1: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 1);
      const wallKosiData1: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 1);
      const wallData2: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 2);
      const wallKosiData2: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 2);
      const wallData3: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 3);
      const wallKosiData3: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 3);

      // コンテンツの作成
      let contents: string = '';
      contents += '<ul>';
      if (wallData1 !== undefined) {
        for (let i = 0; i < wallData1.length; i += 1) {
          contents += `<li  data-itemindex="${String(i)}" class="btnChangeOutWallColor" data-floor="1"><button id="changeOutColorWall1${String(i)}"><img src="${wallData1[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallData1[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const element = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabWall1f.appendChild(element(contents));

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (wallKosiData1 !== undefined) {
        for (let i = 0; i < wallKosiData1.length; i += 1) {
          contents += `<li data-itemindex="${String(i)}" class="btnChangeOutWallKosiColor" data-floor="1"><button id="changeOutColorWallKoshi1${String(i)}"><img src="${wallKosiData1[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallKosiData1[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const tabKoshi1floor = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabKoshi1f.appendChild(tabKoshi1floor(contents));

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (wallData2 !== undefined) {
        for (let i = 0; i < wallData2.length; i += 1) {
          contents += `<li  data-itemindex="${String(i)}" class="btnChangeOutWallColor" data-floor="2"><button id="changeOutColorWall2${String(i)}"><img src="${wallData2[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallData2[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const tabWall2floor = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabWall2f.appendChild(tabWall2floor(contents));

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (wallKosiData2 !== undefined) {
        for (let i = 0; i < wallKosiData2.length; i += 1) {
          contents += `<li data-itemindex="${String(i)}" class="btnChangeOutWallKosiColor" data-floor="2"><button id="changeOutColorWallKoshi2${String(i)}"><img src="${wallKosiData2[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallKosiData2[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const tabKoshi2floor = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabKoshi2f.appendChild(tabKoshi2floor(contents));

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (wallData3 !== undefined) {
        for (let i = 0; i < wallData3.length; i += 1) {
          contents += `<li data-itemindex="${String(i)}" class="btnChangeOutWallColor" data-floor="3" ><button id="changeOutColorWall3${String(i)}"><img src="${wallData3[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallData3[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const tabWall3floor = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabWall3f.appendChild(tabWall3floor(contents));
      document.querySelectorAll('.btnChangeOutWallColor').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
          const floor = Number(((e.currentTarget) as HTMLElement).getAttribute('data-floor'));
          marietta.view3d.webcad.View3dGlobal.shared.changeOutWallColor(floor, itemIndex);
        });
      });
      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (wallKosiData3 !== undefined) {
        for (let i = 0; i < wallKosiData3.length; i += 1) {
          contents += `<li data-itemindex="${String(i)}" class="btnChangeOutWallKosiColor" data-floor="3"><button id="changeOutColorWallKoshi3${String(i)}"><img src="${wallKosiData3[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${wallKosiData3[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const tabKoshi3floor = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabKoshi3f.appendChild(tabKoshi3floor(contents));
      document.querySelectorAll('.btnChangeOutWallKosiColor').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
          const floor = Number(((e.currentTarget) as HTMLElement).getAttribute('data-floor'));
          marietta.view3d.webcad.View3dGlobal.shared.changeOutWallKosiColor(floor, itemIndex);
        });
      });

      // カレントを表示
      this.initCurrentTexture();

      const self = this;
      (self.tabWall1f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabKoshi1f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabWall2f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabKoshi2f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabWall3f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabKoshi3f).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
    }

    /**
     * 選択状態の更新
     */
    initCurrentTexture() {
      // 情報をGET
      const wallData1: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 1);
      const wallKosiData1: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 1);
      const wallData2: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 2);
      const wallKosiData2: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 2);
      const wallData3: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 3);
      const wallKosiData3: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.WallKosi, 3);

      const self = this;
      wallData1.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabWall1f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabWall1f').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      wallKosiData1.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabKoshi1f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabKoshi1f').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });
      wallData2.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabWall2f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabWall2f').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      wallKosiData2.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabKoshi2f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabKoshi2f').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });
      wallData3.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabWall3f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabWall3f').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      wallKosiData3.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabKoshi3f').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabKoshi3f').querySelectorAll('li')[index].classList.add('is-active');
        }
      });
    }

    /**
     * 選択中のテクスチャをカレント表示
     */
    updateCurrentTexture = (e) => {
      (e.currentTarget).parentElement.querySelectorAll('li').forEach((elem) => {
        elem.classList.remove('is-active');
      });
      (e.currentTarget).classList.add('is-active');
    }

    /**
     * 表示するフロア設定
     */
    initFloors() {
      (this.viewObj).querySelectorAll('.tabMenu').forEach((elem) => {
        elem.querySelectorAll('label').forEach((_param) => {
          const param = _param;
          param.style.display = 'block';
        });
      });
      const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
      for (let i = marietta.webcad.WebCADGlobal.MAX_FLOORS; i > highestFloor; i -= 1) {
        (this.viewObj).querySelectorAll('.tabMenu').forEach((_elem) => {
          const elem = _elem;
          elem.querySelectorAll('label')[i * 2 - 1].style.display = 'none';
          elem.querySelectorAll('label')[i * 2 - 2].style.display = 'none';
        });
      }
    }
}
export default OutColorMenu;
